import React from 'react'

const Circle = ({ cName, children}) => {
  return (
    <div className={cName}>{children}</div>
  )
}

export default Circle
